'use client';

import { c as _c } from "react/compiler-runtime";
import { Lock, Server, ShieldCheck, UserCheck } from 'lucide-react';
import { useEffect } from 'react';
import Button from '../common/Button';
import Modal, { ModalContent, ModalFooter, ModalHeader } from '../HOC/Modal';
type Props = {
  closeHandler: () => void;
};
const PRIVATE_POST_MODAL_SEEN_KEY = 'localPostModalSeen';
export const PrivatePostExplanationModal = t0 => {
  const $ = _c(14);
  const {
    closeHandler
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-2"><Lock className="text-primary" /><h2 className="text-xl font-semibold">Local Posts</h2></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== closeHandler) {
    t3 = <ModalHeader closeHandler={closeHandler}>{t2}</ModalHeader>;
    $[2] = closeHandler;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-lg">Local posts stay entirely on your device and never reach our servers.</p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex items-start gap-3"><ShieldCheck className="mt-1 text-primary" /><div><h3 className="font-semibold">Complete Privacy</h3><p className="text-sm text-textSecondary">Everything you write in local posts is stored only on your device. No one else can see it — not even us.</p></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex items-start gap-3"><UserCheck className="mt-1 text-primary" /><div><h3 className="font-semibold">Perfect For Personal Use</h3><p className="text-sm text-textSecondary">Use local posts for research notes, personal journaling, health tracking, or anything you want to keep completely private.</p></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ModalContent><div className="space-y-6 py-2">{t4}<div className="space-y-4">{t5}{t6}<div className="flex items-start gap-3"><Server className="mt-1 text-amber-500" /><div><h3 className="font-semibold">Factiii Limitations</h3><p className="text-sm text-textSecondary">Some factiiis may not work as intended in local posts since they require server interaction.</p></div></div></div></div></ModalContent>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== closeHandler) {
    t8 = <ModalFooter><Button text="Got it" variant="PRIMARY" onClick={closeHandler} /></ModalFooter>;
    $[8] = closeHandler;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== closeHandler || $[11] !== t3 || $[12] !== t8) {
    t9 = <Modal closeHandler={closeHandler}>{t3}{t7}{t8}</Modal>;
    $[10] = closeHandler;
    $[11] = t3;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};
export const hasSeenPrivatePostModal = (): boolean => {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(PRIVATE_POST_MODAL_SEEN_KEY) === 'true';
};
function _temp() {
  if (typeof window !== "undefined") {
    localStorage.setItem(PRIVATE_POST_MODAL_SEEN_KEY, "true");
  }
}